import type { Category } from "@@/shared/categories/category";
import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const categoryGroups = ["ACCOMMODATION_TYPE", "PRODUCT_TEMPLATE"] as const;
type CategoryGroup = (typeof categoryGroups)[number];
const categoryGroupZodSchema = z.enum(categoryGroups);
const categoryGroup = toObjectMap<CategoryGroup>([...categoryGroups]);

const isCategoryPartOfGroup = (category: Category) => {
    return (categoryGroup: CategoryGroup): boolean =>
        category.groups.some(group => categoryGroup === group);
};

export {
    categoryGroup,
    categoryGroupZodSchema,
    categoryGroups,
    isCategoryPartOfGroup,
};
export type { CategoryGroup };
